export default __webpack_public_path__ + "static/svensk_eid-de2a82f0fa86fee8750aa66964f1effb.png";